import React, {useEffect} from 'react';
import { clearUser } from '../../redux/actions/authActions';
import { useDispatch, useSelector } from 'react-redux';
import API from '../../utils/api';
import { useState } from 'react';
import axios from 'axios';
import { logoutUser } from '../../redux/actions/authActions';
import Fetchs3image from '../../utils/fetchs3image';
import { Link } from 'react-router';
import { useNavigate } from 'react-router-dom';
const Dashboard = () => {
    const navigate = useNavigate();
    const location = useSelector((state) => state.location.location);
    const [page, setPage] = useState(1);
    const dispatch = useDispatch();
    const [places,setPlaces] = useState([]);
    const [loading,setLoading] = useState(true)

    const [query, setQuery] = useState('');
    const [debouncedQuery, setDebouncedQuery] = useState('');
    const [results, setResults] = useState([]);

// 1. Debounce input by 800ms
useEffect(() => {
  const handler = setTimeout(() => {
    setDebouncedQuery(query);
  }, 800);

  return () => {
    clearTimeout(handler);
  };
}, [query]);

// 2. Call API when debouncedQuery changes
useEffect(() => {
  if (!debouncedQuery) {
    setResults([]);
    return;
  }

  // Example fetch — replace with your actual API call
  const fetchPlaces = async () => {
      console.log('running fetch city')
      try {
        const res = await axios({
          method:'POST',
          url:'https://api.heytout.com/places/search',
          data: {
              name:debouncedQuery
          }
        })
        const data = res;
        console.log(res.data)
        setResults(res.data);
      } catch (err) {
        console.error('Error fetching cities:', err);
      }
    };

    fetchPlaces();
  }, [debouncedQuery]);




    const fetchplaces = () =>{
        // API.fetch({
        //     method:'POST',
        //     endpoint:'/places/list',
        //     data:{}
        // }).then(res=>{
        //     setPlaces(res.data)
        // }).catch(error=>{
        // })
        console.log(location)
        if(location) {
            axios.post('https://api.heytout.com/places/list',{
                lat:location ? location.center[1] : 36.408483954142774,
                long:location ? location.center[0] : -105.57314473132053,
                distance:10000,
                page_size:10,
                page_number:page
        }).then(res=>{
            setPlaces(res.data.places)
            setLoading(false)
        }).catch(error=>{
            console.log('the error',error)
        })

        } else {
            window.alert('need a location')
        }
    }
    const moreplaces = () => {
        axios.post('https://api.heytout.com/places/list',{
            lat:location ? location.center[1] : 36.408483954142774,
            long:location ? location.center[0] : -105.57314473132053,
            distance:10000,
            page_size:10,
            page_number:page+1
           
    }).then(res=>{
        setPage(page+1)
        console.log('GOT MORE PLACES')
        setPlaces(prev => [...prev, ...res.data.places])
        setLoading(false)
    }).catch(error=>{
        console.log('the error',error)
    })
    }
    const deleteplace = (id) => {
        axios.post('https://api.heytout.com/places/delete',{
            id:id
        }).then(res=>{
    }).catch(error=>{
        console.log('the error delteing places',error)
    })
    }
    console.log('THE STATE',results)
    return (
        <div className="tcontainer">
            <div className="trow">
                <div style={{width:200,marginBottom:10}}>
                <input className="tinput"
                                                    type="text"
                                                    placeholder="find a place..."
                                                    value={query}
                                                    onChange={(e) => setQuery(e.target.value)}
                
                />
                </div>
                <div className="tcol"></div>
            </div>
            {results.length > 0 &&
            <div className="trow pslist">
                {results.map(r=>{
                    return (
                        <div className="psr" onClick={()=>{
                            navigate("/editplace/" + r.id)
                        }}>{r.name}</div>
                    )
                })}
            </div>
            
            }
            <div className="trow">
                <button onClick={fetchplaces}>fetch places</button>
            </div>

            {loading ? null : (
                <div>
                    {places.map(p=>{
                        var i = Fetchs3image({
                            bucket:p.placeimages[0]?.bucket,
                            key:p.placeimages[0]?.key,
                            width:100
                        })
                        return (
                            <div style={styles.place} key={p.id}>
                                <div style={styles.left}>
                                    <img src={i} style={styles.image}/>
                                </div>
                                <div style={styles.right}>
                                {p.name}
                                <button onClick={()=>{
                                    deleteplace(p.id)
                                }}>delete</button>

                                <button onClick={()=>{
                                    navigate("/editplace/" + p.id)
                                    }}>edit</button>


                                </div>
                            </div>
                        )
                    })}
                    <button
                        onClick={moreplaces}
                    >more places</button>
                    </div>
            )}
        </div>
    )
}


export default Dashboard;

const styles = {
    place : {
        padding:15,
        border:'.5px solid lightgrey',
        margin:10,
        display:'flex',
        flexDirection:'row'
    },
    image : {
        width:300,
    },
    right: {
        alignItems:'center',
        justifyContent:'center',
        flex:1,
        display:'flex',
        flexDirection:'column'
    }
}